module.exports = __webpack_public_path__ + "img/b5813b5.jpg";